import React from "react";
import { Link } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";

function Blog() {
  const blogs = [
    {
  id: 1,
  title: "Branding Beyond Logos: Building Meaningful Brand Experiences",
  image: "/assets/img/blog/1.jpg",
  date: "19 February 2026",
  description:
    "Branding today goes far beyond a logo or colour palette. It is about creating meaningful experiences that people remember and connect with.",
  link: "/blog-details-1",
},
    {
      id: 2,
      title: "Branding Lessons Every Growing Business Should Learn",
      image: "/assets/img/blog/2.jpg",
      date: "05 February 2026",
      link: "/blog-details-2",
    },
    {
      id: 3,
      title: "Common UI/UX Mistakes Brands Still Make",
      image: "/assets/img/blog/3.jpg",
      date: "22 January 2026",
      link: "/blog-details-3",
    },
    {
      id: 4,
      title: "Content That Connects: Storytelling for Modern Brands",
      image: "/assets/img/blog/4.jpg",
      date: "08 January 2026",
      link: "/blog-details-4",
    },
    {
      id: 5,
      title: "Creative Thinking: Turning Business Problems into Design Solutions",
      image: "/assets/img/blog/5.jpg",
      date: "25 December 2025",
      link: "/blog-details-5",
    },
    {
      id: 6,
      title: "Design That Sells: The Role of Visuals in Business Growth",
      image: "/assets/img/blog/6.jpg",
      date: "11 December 2025",
      link: "/blog-details-6",
    },
    {
      id: 7,
      title: "Designing Campaigns That People Actually Remember",
      image: "/assets/img/blog/7.jpg",
      date: "27 December 2025",
      link: "/blog-details-7",
    },
  ];

  return (
    <>
      <Header />

      <section
        className="container"
        style={{
          paddingTop: "140px",
          paddingBottom: "100px",
          maxWidth: "1100px",
          margin: "0 auto",
        }}
      >
        <p
          style={{
            color: "#888",
            marginBottom: "20px",
            fontSize: "14px",
          }}
        >
          Home / Blog
        </p>

        <h1
          style={{
            fontSize: "60px",
            fontWeight: "300",
            lineHeight: "1.1",
            marginBottom: "80px",
          }}
        >
          Exploring the World
          <br />
          Through Our Blog
        </h1>
          
        {blogs.map((blog) => (
          <div
            key={blog.id}
            style={{
              display: "flex",
              gap: "30px",
              padding: "30px 0",
              borderBottom: "1px solid #e5e5e5",
              alignItems: "center",
            }}
          >
            <img
              src={blog.image}
              alt={blog.title}
              style={{
                width: "250px",
                height: "160px",
                objectFit: "cover",
              }}
            />

            <div style={{ flex: 1 }}>
              <p
                style={{
                  color: "#999",
                  fontSize: "13px",
                  marginBottom: "10px",
                }}
              >
                {blog.date}
              </p>

              <h3
                style={{
                  fontSize: "24px",
                  marginBottom: "15px",
                  lineHeight: "1.4",
                }}
              >
                {blog.title}
              </h3>

              <Link
                to={blog.link}
                style={{
                  color: "#000",
                  textDecoration: "none",
                  fontWeight: "500",
                }}
              >
                Read More →
              </Link>
            </div>
          </div>
        ))}
      </section>

      <Footer />
    </>
  );
}

export default Blog;